<template>
  <div class="wrapper">
    <div class="wrapper-box">
      <div class="table-wrapper">
        <div class="table-header">
          <div
            class="header"
            v-for="(item, index) in headerNameList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <vue-seamless-scroll
          :data="tableList"
          :class-option="classOption"
          class="table-body"
        >
          <div class="table-list">
            <div class="line" v-for="(item, index) in tableList" :key="index">
              <div class="line-item1">
                <div class="round">{{ index + 1 }}</div>
              </div>
              <div class="line-item2">{{ item.name }}</div>
              <div class="line-item3">{{ item.areaName }}</div>
              <div class="line-item3">{{ item.data }}</div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LsAuditorium',
  data() {
    return {
      tableList: [
        {
          name: '新办纳税人课堂、房土两税相关政策解析申报',
          areaName: '丽水市',
          data: '2021-12-20'
        },
        {
          name: '《新工业三十条》政策解读',
          areaName: '遂昌县',
          data: '2021-12-10'
        },
        {
          name: '十九届六中全会精神宣讲',
          areaName: '龙泉市',
          data: '2021-12-10'
        },
        {
          name: '丽水市新生代企业家谈企业发展与传承',
          areaName: '丽水市',
          data: '2021-12-01'
        },
        {
          name: '纳税人学堂-第7期',
          areaName: '丽水市',
          data: '2021-11-24'
        },
        {
          name: '出口退税实操培训',
          areaName: '丽水市',
          data: '2021-11-16'
        },
        {
          name: '限电政策下企业如何调整劳动用工关系',
          areaName: '丽水市',
          data: '2021-10-29'
        },
        {
          name: '纳税人学堂-第6期',
          areaName: '丽水市',
          data: '2021-10-20'
        },
        {
          name: '2021丽水市中小微企业服务券启动仪式',
          areaName: '丽水市',
          data: '2021-09-30'
        },
        {
          name: '研发费用加计扣除政策处理及实务',
          areaName: '丽水市',
          data: '2021-09-29'
        },
        {
          name: '两化融合贯标2.0解读',
          areaName: '丽水市',
          data: '2021-09-28'
        },
        {
          name: '契税法》及《城市维护建设税法》政策解读',
          areaName: '丽水市',
          data: '2021-09-17'
        },
        {
          name: '制造业的管理创新与突破',
          areaName: '丽水市',
          data: '2021-09-08'
        },
        {
          name: '高薪技术企业研发费财务归集实务指导',
          areaName: '丽水市',
          data: '2021-09-01'
        },
        {
          name: '市经信局政策服务对接会',
          areaName: '丽水市',
          data: '2021-08-26'
        },
        {
          name: '设计赋能企业 创新擎启未来',
          areaName: '丽水市',
          data: '2021-08-25'
        },
        {
          name: '税务局长宣讲税收营商环境在线大直播',
          areaName: '丽水市',
          data: '2021-08-25'
        },
        {
          name: '新办纳税人课堂',
          areaName: '丽水市',
          data: '2021-08-20'
        },
        {
          name: '知识产权助推企业发展的重要性',
          areaName: '丽水市',
          data: '2021-08-11'
        },
        {
          name: '交行普惠 助您经营无忧',
          areaName: '丽水市',
          data: '2021-08-06'
        }
      ],
      pageNum: 1,
      pageSize: 5,
      totalRecord: 5,
      headerNameList: [
        {
          name: '序号'
        },
        {
          name: '直播名称'
        },
        {
          name: '所属区域'
        },
        {
          name: '创建时间'
        }
      ]
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 8, // 开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import './style/common.scss';

.wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  &-box {
    width: 100%;
    height: 100%;
    .right-title {
      color: rgba(255, 255, 255, 100);
      font-size: 0.18rem;
    }
    .table-wrapper {
      width: 100%;
    }
    .table-header {
      width: 100%;
      display: flex;
      .header {
        flex: 1;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        background-color: rgba(0, 164, 221, 0.21);
        color: rgba(255, 255, 255, 65);
      }
    }
    .table-body {
      width: 100%;
      height: 3.5rem;
      overflow: hidden;
      box-sizing: border-box;
      .table-list {
        padding: 0;
        margin: 0;
        width: 100%;
      }
      .line {
        display: flex;
        justify-content: space-around;
        width: 100%;
        .line-item1 {
          flex: 1;
          text-align: center;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: center;
          .round {
            margin: 0 auto;
            margin-top: 0.05rem;
            width: 0.3rem;
            height: 0.3rem;
            line-height: 0.3rem;
            border-radius: 50%;
            color: #fff;
            font-size: 0.16rem;
            box-shadow: inset 0px 0px 8px 0px rgba(18, 254, 253, 1);
          }
        }
        .line-item2 {
          flex: 1;
          height: 0.4rem;
          line-height: 0.4rem;
          color: #fff;
          font-size: 0.14rem;
          text-align: left;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .line-item3 {
          flex: 1;
          line-height: 0.4rem;
          text-align: center;
          height: 0.4rem;
          color: #fff;
          font-size: 0.14rem;
        }
      }
      .line:nth-child(even) {
        background-color: rgba(0, 18, 34, 0.4);
      }
    }
  }
}
</style>
